import React from "react";
const Q2 = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>
      <div className="ans-bank">
        <div className="qta">Selection and Notification of Winner?</div>
        <p>
          The Winner will be selected by a random drawing, under the supervision
          of the Sponsor. The Sponsor will notify the Winner(s) by Email within
          7 days followingWinner selection. The Sponsor is not responsible for
          nor shall have no liability for Winner’s failure to receive notices
          due to email security settings that may cause notifications to be
          marked as spam or junk email. Nor shall be Sponsor be liable for the
          Winner’s provision of incorrect or otherwise non-functioning contact
          information. If the Winner 1) fails to claim the prize within 15 days
          from the time the award notification was sent, 2) is found ineligible,
          or 3) does not complete and return an executed declaration and release
          within the specified time frame, the prize maybe forfeited and an
          alternate Winner may be selected. Receipt of the prize (offered in the
          T-Shirt Giveaway)by he Winner is upon the condition of compliance with
          any and all federal, state, and local laws and regulations.IF THE
          WINNER VIOLATES ANY OF THESE OFFICIAL RULES, THE WINNER (AT THE
          SPONSOR’S SOLE DISCRETION) WILL BE DISQUALIFIED, AND ALL PRIVILEGES AS
          WINNER WILL BE IMMEDIATELY TERMINATED.
        </p>
      </div>
    </div>
  );
};

export default Q2;
